import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950">
        <div className="w-8 h-8 border-2 border-teal-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Hard gate: when a user has `must_change_password=true` (either an
  // Owner-invited fresh account or an admin-reset existing one), we
  // funnel them to the rotation page no matter which route they hit.
  // The rotation page itself is unprotected so this redirect doesn't
  // loop on itself.
  if (user.must_change_password && location.pathname !== "/cambiar-password-obligatorio") {
    return <Navigate to="/cambiar-password-obligatorio" replace />;
  }

  // ── Enforce registration completion ──
  // Superadmins have no org — that's by design, don't block them
  if (user.role === "superadmin") {
    return children;
  }

  // If user hasn't finished registration, redirect to the correct step
  const step = user.registration_step;

  if (step === "user_created" || (!user.organization_id && step !== "complete")) {
    // No org yet → go create one
    return <Navigate to="/register/organization" replace />;
  }

  // Note: "org_created" step removed - users now go directly to dashboard after org creation
  // registration_step is set to "complete" when org is created

  return children;
}
